export default "__VITE_ASSET__Cmu58ixc__"